<template>
  <div>
    <el-alert title="使用 webwork 进行图片压缩, 不阻塞主线程, 大文件压缩时体验更好（只支持 .png）（CompressWorker类封装）" type="success"
      :closable="false"></el-alert>
    <el-row :gutter="10">
      <el-col :xs="24" :sm="12" style="margin: 10px 0;">
        <el-upload class="upload-demo" drag :multiple="false" :http-request="uploadImg" :show-file-list="false"
          action="/" accept=".png">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或 <em>点击上传</em></div>
          <div class="el-upload__tip" slot="tip">只能上传 png 文件</div>
        </el-upload>
      </el-col>
      <el-col :xs="24" :sm="12" style="margin: 10px 0;">
        <el-row :gutter="10" v-loading="compressing">
          <el-col :span="12">
            <el-image style="width: 180px; height: 180px; flex-shrink:0 ;" :src="imgUrl"
              :preview-src-list="[imgUrl]" fit="contain">
            </el-image>
          </el-col>
          <el-col :span="12">
            <el-descriptions title="压缩信息" :column="1" v-if="compressResult.compressedSize">
              <el-descriptions-item label="压缩前">{{ getSizeTrans(compressResult.originalSize)
              }}</el-descriptions-item>
              <el-descriptions-item label="压缩后">{{ getSizeTrans(compressResult.compressedSize)
              }}</el-descriptions-item>
              <el-descriptions-item label="压缩率">{{ compressResult.rateString }}</el-descriptions-item>
              <el-descriptions-item label="减少">
                <el-tag size="small" type="success">
                  -{{ ((1 - compressResult.rate) * 100).toFixed(2) + '%' }}
                </el-tag>
              </el-descriptions-item>
            </el-descriptions>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" style="margin: 10px 0;">
        <el-button :disabled="!imgUrl" type="primary" @click="download">下载</el-button>
      </el-col>
    </el-row>
  </div>
</template>
<script>
// Import the worker
// This is the bundled worker
import { getSizeTrans } from '../utils/index.js';
import { CompressWorker } from './CompressWorker.js';
export default {
  name: 'Base',
  data() {
    return {
      imgUrl: '',
      imgName: '',
      compressResult: {},
      compressing: false,
      count: 0
    }
  },
  mounted() {
    this.compressWorker = new CompressWorker();
  },
  methods: {
    getSizeTrans,
    async uploadImg(e) {
      this.compressing = true;
      this.imgName = e.file.name;
      this.compressWorker.compress(e.file, {
        minimumQuality: 30,
        quality: 100
      }).then((result) => {
        console.log(result);
        this.compressing = false;
        const url = URL.createObjectURL(result.blob);
        this.imgUrl = url;
        this.compressResult = result;
      }).catch((err) => {
        console.error(err);
        this.compressing = false;
      })
    },
    download() {
      const link = document.createElement('a');
      link.href = this.imgUrl;
      link.download = this.imgName; // 设置下载文件的名称
      link.click();
    },
  },
  beforeDestroy() {
    // Terminate the worker when the component is destroyed
    if (this.compressWorker) {
      this.compressWorker.terminate();
    }
  }
}
</script>
